import { render, staticRenderFns } from "./cate-list.vue?vue&type=template&id=645f9d24&scoped=true&"
import script from "./cate-list.vue?vue&type=script&lang=js&"
export * from "./cate-list.vue?vue&type=script&lang=js&"
import style0 from "./cate-list.vue?vue&type=style&index=0&id=645f9d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f9d24",
  null
  
)

export default component.exports